import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { GatewayRoleModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/roles/models/output/gateway-role.model';

import { useAppSelector } from '@app/core/hooks';
import { useCpmsBoGetRoleQuery } from '@app/core/service/cpms-bo-role.service';
import { cpmsBoRoleSlice } from '@app/core/service/cpms-bo-role.slice';

export interface RoleFilterStateControllerProps {
  value: GatewayRoleModel['id'];
  onRemove: FilteredItemProps['onRemove'];
}

export const RoleFilterStateController = ({
  value,
  onRemove,
}: RoleFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const role = useAppSelector((state) =>
    cpmsBoRoleSlice.selectors.selectById(state, value),
  );

  const { data: roleApiData } = useCpmsBoGetRoleQuery(value, {
    skip: !!role,
  });

  const roleName = role?.name ?? roleApiData?.name ?? '';

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem icon="settings-04" label={roleName} onRemove={onRemove} />
  );
};
